import React from "react";

import { getCurrencyAmount } from "../../helpers/helpers";
import P from "../../shared/typography/P";
import InfoCard from "./InfoCard";
import SectionWrapper from "./SectionWrapper";

const FeatureSection = ({ features, currentSlide, billWithSolar }) => {
    const billWithSolarStr = billWithSolar?.replace(/[^0-9]/g, "");
    const lifetimeSavings = Number(billWithSolarStr) * 12 * 25;
    return (
        <SectionWrapper>
            <div className=" bg-gray-200 p-1 text-center rounded-xl mb-3 ">
                <P className="lg:text-lg xl:text-lg">Offering Features</P>
            </div>

            <div className="flex flex-nowrap justify-center gap-3 items-center">
                {features.map((item, index) => (
                    <InfoCard
                        key={index}
                        title={item.title}
                        value={item.value}
                        icon={item.icon}
                    />
                ))}
            </div>

            {currentSlide === 1 && (
                <div className=" bg-linear-blue-white p-1 rounded-2xl mt-3 flex justify-center items-center">
                    <P className="text-white font-medium md:text-sm lg:text-sm xl:text-sm">
                        Lifetime savings with solar{" "}
                        {getCurrencyAmount(lifetimeSavings)}
                    </P>
                </div>
            )}
        </SectionWrapper>
    );
};

export default FeatureSection;
